import * as Ariakit from '@ariakit/react'
import * as React from 'react'

interface PopoverTriggerProps extends Omit<Ariakit.PopoverDisclosureProps, 'store'> {
  state: Ariakit.PopoverStore
}

export const PopoverTrigger = React.forwardRef(
  ({ state, ...props }: PopoverTriggerProps, ref: React.ForwardedRef<HTMLButtonElement>) => (
    <Ariakit.PopoverDisclosure ref={ref} store={state} {...props} />
  )
)

export const PopoverAnchor = Ariakit.PopoverAnchor
